export default __webpack_public_path__ + "static/look-2-alt-5eb36beb269bd3330b52a79d9c0599f7.png";